export default {"src":"/_next/static/media/phoneCalling.5cc70a40.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};